import React from 'react';

import { StyledSlideList, StyledSliderSlideElement } from './SlideList.styles';

import { SlideProps } from '../Slider.types';
import { SlideListProps } from './SlideList.types';

import { getElementKeyDatasetForInfiniteAnimation } from '../../../../';

const SlideList = ({
  componentClassname = 'slide-list',
  groupedData,
  isChangingSlide,
  transitionType,
  numberOfItemsVisibleForRotateTransition,
  translationPercentageForRotateTransition,
  isInfinite,
  sliderState,
  numberOfSlide,
  spacingForSlide,
  renderComponentMethod,
}: SlideListProps) => {
  if (!groupedData.length) {
    return null;
  }

  const checkIfSlideIsVisibleInRotateTransition = (
    selectedSlideIndex: number,
    currentSlideIndex: number,
    numberOfItemsVisible: number,
    numberOfSlide: number,
  ) => {
    if (transitionType !== 'rotate') {
      return false;
    }
    const defaultCheck =
      selectedSlideIndex >=
        currentSlideIndex - Math.floor(numberOfItemsVisible / 2) &&
      selectedSlideIndex <=
        currentSlideIndex + Math.floor(numberOfItemsVisible / 2);
    if (isInfinite) {
      /**
       * If you have less element than half the number of slides visible before the selected slide
       * return true if the element is at the end of the slider and should be display
       */
      const infiniteCheckBefore =
        selectedSlideIndex < Math.floor(numberOfItemsVisible / 2) &&
        numberOfSlide - currentSlideIndex - selectedSlideIndex <=
          Math.floor(numberOfItemsVisible / 2);
      /**
       * If you have less element than half the number of slides visible after the selected slide
       * return true if the element is at the start of the slider and should be display
       */
      const infiniteCheckAfter =
        selectedSlideIndex >=
          numberOfSlide - Math.floor(numberOfItemsVisible / 2) &&
        numberOfSlide - selectedSlideIndex + currentSlideIndex <=
          Math.floor(numberOfItemsVisible / 2);
      return defaultCheck || infiniteCheckBefore || infiniteCheckAfter;
    }
    return defaultCheck;
  };

  return (
    <StyledSlideList
      className={`${componentClassname} ${
        isChangingSlide ? `${componentClassname}--is-changing-slide` : ''
      }`}
    >
      {groupedData.map((groupedSlide, mapIndex) => (
        <StyledSliderSlideElement
          key={mapIndex}
          className={`${componentClassname}__slide ${
            sliderState.currentSlideIndex === mapIndex
              ? `${componentClassname}__slide--is-selected`
              : ''
          } ${
            checkIfSlideIsVisibleInRotateTransition(
              sliderState.currentSlideIndex,
              mapIndex,
              numberOfItemsVisibleForRotateTransition,
              groupedData.length,
            )
              ? `${componentClassname}__slide--is-visible`
              : ''
          }`}
          keyDataset={
            isInfinite
              ? getElementKeyDatasetForInfiniteAnimation(
                  sliderState.currentSlideIndex,
                  mapIndex,
                  groupedData.length,
                )
              : mapIndex - sliderState.currentSlideIndex
          }
          numberOfSlide={groupedData.length}
          translationPercentageForRotateTransition={
            translationPercentageForRotateTransition
          }
          transitionType={transitionType}
          spacingForSlide={spacingForSlide}
          role="group"
          aria-label={`${mapIndex + 1} / ${numberOfSlide}`}
        >
          {groupedSlide.map((slide: SlideProps, index) => {
            return (
              <div
                data-index-indicator={slide.id ?? index}
                key={slide.id ?? index}
                className={`${componentClassname}__slide-inner`}
              >
                {renderComponentMethod({
                  item: slide,
                  isSelected: sliderState.currentSlideIndex === mapIndex,
                })}
              </div>
            );
          })}
        </StyledSliderSlideElement>
      ))}
    </StyledSlideList>
  );
};
SlideList.displayName = 'SlideList';

export default SlideList;
